/* eslint-disable array-callback-return */
/* eslint-disable no-unused-expressions */
/* eslint-disable no-unused-vars */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/jsx-indent */
import React, {
  useState,
  useEffect,
  useLayoutEffect,
  useRef,
  useMemo,
} from 'react';
import { getObjectValue } from '@utility/utills';
import findIndex from 'lodash/findIndex';
import filter from 'lodash/filter';
import cn from 'classnames';
import style from './modifiers.module.scss';
import { LABEL } from '../../veriables';
import _ from 'lodash';
import { flowType } from '@utility/userInfo';
import { ReactComponent as UpArrow } from '@assets/images/upArrow.svg';
import { ReactComponent as DownArrow } from '@assets/images/downArrow.svg';
import { TouchableDiv, TouchableButton } from '@components/common/Touchable';

const getPath = (data, dataToAppend) => {
  const arrayData = [...data];
  if (dataToAppend) {
    arrayData.push(dataToAppend);
  }
  return arrayData.join('|');
};

const getSelections = ({ minimum, maximum }) => {
  let selector = '';
  if (minimum === maximum) {
    if (minimum > 1) {
      selector = `Pick ${maximum}`;
    } else if (minimum === 1) {
      selector = `Pick ${maximum}`;
    } else {
      selector = 'Pick any (optional)';
    }
  } else if (minimum !== maximum) {
    if (minimum === 0) {
      selector = `${LABEL().PICK_UP_TO} ${maximum} (${LABEL().OPTIONAL})`;
    } else {
      selector = `Pick ${minimum} to ${maximum} items`;
    }
  }

  return selector;
};

const getBadgeName = menuItem => {
  if (menuItem?.outOfStock) {
    return LABEL().OUT_OF_STOCK;
  }

  const badgeLabels = {
    1: LABEL().VIEW_ONLY,
    2: LABEL().NEW_ITEM,
    3: LABEL().LIMITED_TIME,
    4: LABEL().FEATURED,
    5: LABEL().SPECIAL,
    6: LABEL().COMING_SOON,
    7: LABEL().LIMITED_QUANTITY,
    8: LABEL().ADDITIONAL_TIME,
    9: LABEL().TIME_RESTRICTED,
  };

  return badgeLabels[menuItem.badge] || '';
};

const getBadgeStyle = menuItem => {
  if (menuItem?.outOfStock) {
    return 'od-badge-nostock';
  }

  const badgeStyle = {
    1: 'od-badge-view',
    2: 'od-badge-new',
    3: 'od-badge-limited',
    4: 'od-badge-featured',
    5: 'od-badge-special',
    6: 'od-badge-comingsoon',
    7: 'od-badge-limitedquantity',
    8: 'od-badge-additionaltime',
  };

  return badgeStyle[menuItem.badge] || '';
};

const isTableTop = flowType() === 'tableTop';
const isKiosk = flowType() === 'kiosk';

const RenderMods = ({
  data,
  modId,
  modifierGroup,
  itemInfo,
  item,
  isSlider,
  showEdit,
  onClickModifer,
  onClickAddModifer,
  onCountNegitiveModifer,
  isActive,
  isLimitOver,
  isGlobalModFuncDisplay,
  modifiersHashTable,
  disable,
  isServerApp,
  supportsModifierDescription,
  isNestedModifier,
  modifierNote,
  handleNote,
  showOnlyCount,
  hideBtns,
  onCountModifer,
  modifierCount,
  handleGlobalModFunction,
  auth,
  isNestedModifierSelected,
  onSlideSelect,
  modifierGroupsHashTable,
  getGlobalMod,
  selectedModId,
  setModId,
  browserOrtablet,
  setBrowserOrtablet,
  isCounter,
  isModifierRequired,
  serverAppTheme,
  globalModFuncDisplayIds,
  showNestedIcon,
  setShowNestedIcon,
  modifier,
  modifierEdit,
  selectedModifiers,
  isDriveThru,
  maxValue,
  itemWeight,
  itemCount,
  ...props
}) => {
  const [show, setShow] = useState(false);
  const itemRef = useRef(null);
  const [
    isLeftSwipeWithNestedModifier,
    setIsLeftSwipeWithNestedModifier,
  ] = useState(false);
  const [
    isLeftSwipeWithoutNestedModifier,
    setIsLeftSwipeWithoutNestedModifier,
  ] = useState(false);
  const [showQty, setIsShowQty] = useState(true);

  const options = {
    rootMargin: '0px 0px 10px 0px',
    threshold: [0.1, 0.9],
  };
  const handleObserver = (entries, observe) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        setShow(true);
        observe.unobserve(entry.target);
      }
    });
  };

  const disableModifierMemosValue = () => {
    const deviceInfo = JSON.parse(window.sessionStorage.getItem('deviceInfo'));
    return (
      deviceInfo?.deviceGroup?.serverAppSettings?.disableModifierMemos !== true
    );
  };

  useLayoutEffect(() => {
    setIsShowQty(modifiersHashTable[data?.modifierId]?.cardType === 0);
    const observer = new IntersectionObserver(handleObserver, options);
    if (itemRef.current) {
      observer.observe(itemRef.current);
    }
    return () => {
      observer.disconnect();
    };
  }, []);



  const handleLeftSwipe = () => {
    if (isActive) {
      if (isLeftSwipeWithoutNestedModifier) {
        setIsLeftSwipeWithoutNestedModifier(false);
      }
      if (isLeftSwipeWithNestedModifier) {
        setIsLeftSwipeWithNestedModifier(false);
      }
    }
  };
  const ModifierStyle = useMemo(() => {
    const itemTextColor = (item, isActive) => {
      return {
        color: item.outOfStock
          ? serverAppTheme?.secondary_btn_disable_text
          : isActive
            ? serverAppTheme?.modifierSelectedText
            : serverAppTheme?.primary_text,
      };
    };
    const itemTextWordBrk = (data, item) => {
      return {
        wordBreak:
          data?.name?.length > 18 || item?.name?.length > 18
            ? 'break-word'
            : 'normal',
        lineHeight:
          data?.name?.length > 18 || item?.name?.length > 18 ? '1.2' : '1.1',
        color: item.outOfStock
          ? serverAppTheme?.secondary_btn_disable_text
          : isActive
            ? serverAppTheme?.modifierSelectedText
            : serverAppTheme?.primary_text,
      };
    };
    const modifierIncrement = { backgroundColor: serverAppTheme?.primaryBtn };
    return { itemTextColor, itemTextWordBrk, modifierIncrement };
  }, [serverAppTheme]);

  const modName = (data, item, isActive) => {
    const name = data.name || item.name;
    if (isKiosk) {
      return name;
    } else {
      return <span className={style.doubleLineTruncate}>{name}</span>;
    }
  };

  const serverAppImage =
    item?.serverAppAsImage && item?.intermediateImageUrl
      ? `url(${item?.intermediateImageUrl})`
      : '';


  return (
    <TouchableDiv
      key={data.modifierId}
      id={data.modifierId}
      className={cn(
        style.modifier,
        itemInfo.menuItem.outOfStock === true ? style.opacity0 : '',
        isKiosk ? 'col-6 p-1' : 'p-0 position-relative mb-1',
        (props?.index + 1) % 5 !== 0 && 'mr-1'
      )}
      onClick={e => {
        e.preventDefault();

        if (e.target.closest('.modifierBtn')) {
          e.stopPropagation();
          return;
        }

        if (
          !itemInfo.menuItem.outOfStock &&
          !(item.badge === 1 || item.badge === 6) &&
          !isSlider
        ) {
          if (!item.outOfStock) {
            setModId();
            onClickModifer(
              isActive,
              data,
              isLimitOver,
              item,
              isGlobalModFuncDisplay,
              e
            );
            showNestedIcon && setShowNestedIcon(prev => !prev);
          }
        }
        handleLeftSwipe();
      }}
      role="presentation"
      parentRef={itemRef}
      style={{
        width: '120.5px',
      }}
    >
      {show && (
        <>
          {modifiersHashTable[data.modifierId] &&
            modifiersHashTable[data.modifierId].modifierGroupLinks?.length ===
            0 ? (
            <div
              className={cn(
                !isActive
                  ? isModifierRequired
                    ? cn('btn-ripple  h-100', style.requiredModifier)
                    : cn('btn-ripple  h-100', style.optionalModifier)
                  : cn(style.activeModifier, 'h-100', ' btn-ripple'),
                'p-1',
                !isActive && (disable || isLimitOver) && 'opacity-6'
              )}
              style={{
                backgroundImage: serverAppImage,
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
                backgroundSize: 'cover',
                backgroundColor: modifiersHashTable[data.modifierId]
                  ?.serverAppButtonColor
                  ? modifiersHashTable[data.modifierId]?.serverAppButtonColor
                  : !isActive
                    ? isModifierRequired
                      ? serverAppTheme?.modifiers_tile_bg
                      : serverAppTheme?.optional_mod_tile
                    : serverAppTheme?.selected,
              }}
            >
              <div className="w-100 h-100">
                {!isServerApp && (item.outOfStock || item.badge !== 0) && (
                  <div
                    className={cn(
                      'col-12 px-0 text-right',
                      item.outOfStock && 'h-15'
                    )}
                  >
                    <div className="w-100">
                      <span
                        style={{ top: 0 }}
                        className={cn(
                          style.removeOutStock,
                          'position-absolute fs-12',
                          getBadgeStyle(item),
                          supportsModifierDescription &&
                            item.description &&
                            item.tags &&
                            item.tags.length > 0
                            ? style.badgeBottomWhenDesciption
                            : '',
                          style.badgeWithoutTag
                        )}
                      >
                        {getBadgeName(item)}
                      </span>
                    </div>
                  </div>
                )}
                {isServerApp ? (
                  <div className="col-12 px-0 h-60 d-flex align-items-start justify-content-start">
                    {!(
                      item?.serverAppAsImage && item?.intermediateImageUrl
                    ) && (
                        <div
                          className={cn(
                            'col-12 px-0 fw-100 h-100',
                            isKiosk
                              ? 'fs-20'
                              : data?.name?.length < 14 || item?.name?.length < 14
                                ? 'fs_14'
                                : data?.name?.length >= 14 ||
                                  item?.name?.length <= 16
                                  ? 'fs_14'
                                  : 'fs_14',
                            style.modifierName,
                            isActive && 'color-black'
                          )}
                          style={{
                            wordBreak:
                              data?.name?.length > 18 || item?.name?.length > 18
                                ? 'break-word'
                                : 'normal',
                            lineHeight:
                              data?.name?.length > 18 || item?.name?.length > 18
                                ? '1.2'
                                : (data?.name?.length < 14 ||
                                  item?.name?.length < 14) &&
                                  (data?.name?.length > 10 ||
                                    item?.name?.length > 10)
                                  ? '1.1'
                                  : (data?.name?.length >= 14 ||
                                    item?.name?.length >= 14) &&
                                    (data?.name?.length < 18 ||
                                      item?.name?.length < 18)
                                    ? '1.1'
                                    : '1.1',
                            color: item.outOfStock
                              ? '#A0A0A0'
                              : isActive
                                ? 'black'
                                : serverAppTheme?.primary_text,
                          }}
                        >
                          {modifierGroup?.applyModFunction
                            ? `${modifiersHashTable[
                              modifierGroup.modFunctionModifierId
                            ]?.name
                            }`
                            : ''}
                          {modName(data, item, isActive)}
                        </div>
                      )}
                  </div>
                ) : (
                  <div className="col-12 px-0 h-60 d-flex align-items-start justify-content-start">
                    {!(
                      item?.serverAppAsImage && item?.intermediateImageUrl
                    ) && (
                        <div
                          className={cn(
                            'col-12 px-0 fw-600 h-100',
                            isKiosk ? 'fs-20' : 'fs-14',
                            style.modifierName
                          )}
                        >
                          {modifierGroup?.applyModFunction
                            ? `${modifiersHashTable[
                              modifierGroup.modFunctionModifierId
                            ]?.name
                            }`
                            : ''}
                          {modName(data, item, isActive)}
                        </div>
                      )}
                  </div>
                )}
                <div className="col-12 px-0 h-40">
                  {!data.singleSelection &&
                    modifiersHashTable[data.modifierId] &&
                    modifiersHashTable[data.modifierId].modifierGroupLinks
                      ?.length === 0 && (
                      <div className="col-12 px-0 h-100 d-flex">
                        {isActive &&
                          !data.singleSelection &&
                          !itemInfo.menuItem.outOfStock && (
                            <div
                              className={cn(
                                'h-100 d-flex justify-content-center px-0'
                              )}
                            >
                              <TouchableDiv
                                role="presentation"
                                onClick={(e) => {
                                  e.preventDefault();
                                  e.stopPropagation();
                                  modifierEdit(modifier)
                                }}
                              >
                                <div
                                  className={cn(
                                    'col-12 h-100 d-flex justify-content-center px-0'
                                  )}
                                >
                                  {!['kiosk'].includes(flowType()) &&
                                    showNestedIcon && (
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="14"
                                        height="14"
                                        viewBox="0 0 12 12"
                                        fill="none"
                                      >
                                        <path
                                          d="M10.24 4.08796H4.77418C4.40598 4.08796 4.10622 4.3864 4.10622 4.75296V7.08861H1.86536V1.85708H7.12028V3.07274C7.12028 3.28507 7.29372 3.45774 7.507 3.45774C7.72028 3.45774 7.89372 3.28507 7.89372 3.07274V1.75208C7.89372 1.38552 7.59395 1.08709 7.22575 1.08709H1.75989C1.39168 1.08709 1.09192 1.38552 1.09192 1.75208V7.19361C1.09192 7.56017 1.39168 7.8586 1.75989 7.8586H6.65504L5.9334 8.57703C5.86028 8.64983 5.81997 8.74643 5.81997 8.84933C5.81997 8.95222 5.86028 9.04882 5.93317 9.12162C6.00606 9.19419 6.10333 9.23432 6.20669 9.23432C6.31004 9.23432 6.40684 9.19442 6.4802 9.12162L7.66286 7.944C7.7327 7.87447 7.78497 7.79327 7.81825 7.70203C7.867 7.63624 7.89348 7.55597 7.89348 7.4736C7.89348 7.39124 7.867 7.3112 7.81825 7.2454C7.78497 7.15394 7.7327 7.07274 7.66286 7.00344L6.47997 5.82582C6.40684 5.75302 6.30981 5.71288 6.20645 5.71288C6.10309 5.71288 6.00606 5.75302 5.9334 5.82582C5.7827 5.97585 5.7827 6.22015 5.9334 6.37018L6.65504 7.08861H4.87965V4.85796H10.1346V10.0895H4.87965V8.84933C4.87965 8.63699 4.70622 8.46433 4.49293 8.46433C4.27965 8.46433 4.10622 8.63699 4.10622 8.84933V10.1945C4.10622 10.561 4.40598 10.8595 4.77418 10.8595H10.24C10.6082 10.8595 10.908 10.561 10.908 10.1945V4.75296C10.908 4.3864 10.6082 4.08796 10.24 4.08796Z"
                                          fill="#FFFFFF"
                                        />
                                      </svg>
                                    )}
                                </div>
                              </TouchableDiv>
                            </div>
                          )}
                        {isActive &&
                          !data.singleSelection &&
                          !itemInfo.menuItem.outOfStock && (
                            <div className={cn('col-12 px-0 h-100')}>
                              <div
                                className={cn('col-12 px-0 d-flex modifierBtn')}
                              >
                                <div className="col-5 px-0">
                                  {!showOnlyCount && showQty && (
                                    <TouchableButton
                                      type="button"
                                      style={ModifierStyle.modifierIncrement}
                                      className={cn(
                                        'color-white border-0 justify-content-center align-items-center w-100',
                                        `${hideBtns}`,
                                        style.modifierInc,
                                        !hideBtns && 'd-flex'
                                      )}
                                      onClick={e => {
                                        e.preventDefault();
                                        e.stopPropagation();
                                        onCountModifer(
                                          isActive,
                                          data,
                                          isLimitOver,
                                          false,
                                          item,
                                          modifierCount,
                                          e
                                        );
                                      }}
                                      disabled={!isActive}
                                      aria-label="minusModQtyBtn"
                                      rippleEffect={true}
                                    >
                                      <span>
                                        <i
                                          className={cn(
                                            modifierCount === 1
                                              ? 'fas fa-trash-alt fs-12 color-white d-flex justify-content-center align-items-center'
                                              : 'fas fa-minus fs-12 color-white d-flex justify-content-center align-items-center'
                                          )}
                                        />
                                      </span>
                                    </TouchableButton>
                                  )}
                                </div>
                                {showQty && (
                                  <div className="col-2 px-0 text-center d-flex justify-content-center align-items-center fw-600 fs-14 color-black pl-0">
                                    {' '}
                                    {modifierCount
                                      ? modifierCount * (data.weight || 1)
                                      : ''}
                                  </div>
                                )}
                                <div className="col-5 px-0">
                                  {!showOnlyCount && showQty && (
                                    <TouchableButton
                                      type="button"
                                      style={ModifierStyle.modifierIncrement}
                                      className={cn(
                                        'color-white border-0 justify-content-center align-items-center w-100',
                                        `${hideBtns}`,
                                        style.modifierInc,
                                        !hideBtns && 'd-flex'
                                      )}
                                      onClick={e => {
                                        e.preventDefault();
                                        e.stopPropagation();
                                        if (disable) return;
                                        onCountModifer(
                                          isActive,
                                          data,
                                          isLimitOver,
                                          true,
                                          item,
                                          modifierCount,
                                          e
                                        );
                                      }}
                                      aria-label="plusModQtyBtn"
                                      rippleEffect={true}
                                    >
                                      <span>
                                        <i
                                          className={cn(
                                            'fas fa-plus fs-12 d-flex justify-content-center align-items-center color-white'
                                          )}
                                        />
                                      </span>
                                    </TouchableButton>
                                  )}
                                </div>
                              </div>
                            </div>
                          )}
                        {isServerApp && item.outOfStock && (
                          <div
                            className={cn(
                              'col-5 d-flex justify-content-end px-0 align-items-sm-center',
                              item.outOfStock && 'col-12'
                            )}
                          >
                            <div
                              className={cn(
                                'px-0 h-90 w-25 fs-14 d-flex align-items-center justify-content-center color-white rounded',
                                style.outOfStockButton
                              )}
                            >
                              {LABEL().OUT_OF_STOCK_NUMBER}
                            </div>
                          </div>
                        )}
                      </div>
                    )}
                </div>
                {!isServerApp &&
                  supportsModifierDescription &&
                  item.description !== null && (
                    <div
                      className={cn(
                        style.lineHeight1,
                        'd-flex my-2 pb-10 fs-12',
                        isActive ? style.modDescription : '',
                        !(item.outOfStock === true || item.badge !== 0) &&
                          !(item.tags && item.tags.length > 0) &&
                          !(
                            data.price > 0 ||
                            (item.calories !== null && item.calories > 0)
                          )
                          ? 'pb-20'
                          : ''
                      )}
                    >
                      {item.description && item.description.length > 120
                        ? `${item.description.substring(0, 80)}...`
                        : item.description}
                    </div>
                  )}
              </div>
            </div>
          ) : (
            <div
              className={cn(
                isActive || isNestedModifierSelected(data)
                  ? cn(style.activeModifier, 'color-white btn-ripple h-100')
                  : isModifierRequired
                    ? cn(' btn-ripple h-100', style.requiredModifier)
                    : cn(' btn-ripple h-100', style.optionalModifier),
                'p-1',
                window.innerWidth > 1023
                  ? 'position-sticky'
                  : 'position-relative',
                !isActive && (disable || isLimitOver) && 'opacity-6'
              )}
              style={{
                backgroundImage: serverAppImage,
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
                backgroundSize: 'cover',
                backgroundColor: modifiersHashTable[data.modifierId]
                  ?.serverAppButtonColor
                  ? modifiersHashTable[data.modifierId]?.serverAppButtonColor
                  : !isActive
                    ? isModifierRequired
                      ? serverAppTheme?.modifiers_tile_bg
                      : serverAppTheme?.optional_mod_tile
                    : serverAppTheme?.selected,
              }}
            >
              <div className="w-100 h-100">
                {item && (
                  <>
                    {item.outOfStock && (
                      <div
                        className={cn(
                          'col-12 d-flex justify-content-end px-0 align-items-sm-center',
                          style.outOfStockNumber
                        )}
                      >
                        <div
                          className={cn(
                            'px-0 h-90 w-25 fs-14 d-flex align-items-center justify-content-center color-white rounded',
                            style.outOfStockButton
                          )}
                        >
                          {LABEL().OUT_OF_STOCK_NUMBER}
                        </div>
                      </div>
                    )}
                    {isServerApp ? (
                      <div className="col-12 px-0 h-60 d-flex align-items-start justify-content-start">
                        {!(
                          item?.serverAppAsImage && item?.intermediateImageUrl
                        ) && (
                            <div
                              className={cn(
                                'p-0 fw-100',
                                isKiosk
                                  ? 'fs-20 col-8'
                                  : data?.name?.length <= 14 ||
                                    item?.name?.length <= 14
                                    ? 'fs-14'
                                    : data?.name?.length > 14 ||
                                      item?.name?.length <= 16
                                      ? 'fs-14'
                                      : 'fs-14',
                                'col-12 px-0',
                                style.modifierName,
                                isActive && 'color-black'
                              )}
                              style={ModifierStyle.itemTextWordBrk(
                                data,
                                item,
                                isActive
                              )}
                            >
                              {modifierGroup?.applyModFunction
                                ? `${modifiersHashTable[
                                  modifierGroup.modFunctionModifierId
                                ]?.name
                                }`
                                : ''}
                              {modName(data, item, isActive)}
                            </div>
                          )}
                      </div>
                    ) : (
                      <div className="col-12 px-0 h-60 d-flex align-items-start justify-content-start">
                        {!(
                          item?.serverAppAsImage && item?.intermediateImageUrl
                        ) && (
                            <div
                              className={cn(
                                'p-0 fw-100',
                                isKiosk ? 'fs-20 col-8' : 'col-12 px-0 fs-16'
                              )}
                            >
                              {modifierGroup?.applyModFunction
                                ? `${modifiersHashTable[
                                  modifierGroup.modFunctionModifierId
                                ]?.name
                                }`
                                : ''}
                              {modName(data, item, isActive)}
                            </div>
                          )}
                      </div>
                    )}
                    <div className="col-12 px-0 h-40">
                      {modifiersHashTable[data.modifierId] &&
                        modifiersHashTable[data.modifierId].modifierGroupLinks
                          ?.length > 0 && (
                          <div className="col-12 px-0 h-100 d-flex">
                            <div className="col-12 h-100 px-0 d-flex justify-content-end">
                              {isActive &&
                                !isSlider &&
                                !data?.singleSelection &&
                                !itemInfo?.menuItem?.outOfStock && (
                                  <>
                                    <TouchableDiv
                                      className={cn(
                                        'p-0 fs-12 pr-1',
                                        isKiosk && 'col-2'
                                      )}
                                      role="presentation"
                                      onClick={e => {
                                        e.preventDefault();
                                        e.stopPropagation();
                                        if (
                                          !itemInfo?.menuItem?.outOfStock &&
                                          !(
                                            item.badge === 1 || item.badge === 6
                                          )
                                        ) {
                                          if (!item?.outOfStock) {
                                            onClickModifer(
                                              isActive,
                                              data,
                                              isLimitOver,
                                              item,
                                              'edit'
                                            );
                                          }
                                        }
                                      }}
                                    >
                                    </TouchableDiv>
                                    <div className={cn('col-12 px-0 d-flex')}>
                                      {/* 1. minus button */}
                                      <div className="col-5 px-0">
                                        {!showOnlyCount && showQty && (
                                          <TouchableButton
                                            type="button"
                                            style={{
                                              borderRadius: '0.1rem',
                                              backgroundColor:
                                                serverAppTheme?.primaryBtn,
                                            }}
                                            className={cn(
                                              'color-white border-0 w-100 justify-content-center align-items-center',
                                              `${hideBtns}`,
                                              style.modifierInc,
                                              !hideBtns && 'd-flex'
                                            )}
                                            onClick={e => {
                                              e.preventDefault();
                                              e.stopPropagation();
                                              isKiosk ||
                                                isTableTop ||
                                                modifierGroup?.isWeight === false
                                                ? onCountModifer(
                                                  isActive,
                                                  data,
                                                  isLimitOver,
                                                  false,
                                                  item,
                                                  modifierCount
                                                )
                                                : onCountNegitiveModifer(
                                                  isActive,
                                                  data,
                                                  isLimitOver,
                                                  false,
                                                  item,
                                                  modifierCount
                                                );
                                            }}
                                            disabled={!isActive}
                                            aria-label="minusModQtyBtn"
                                          >
                                            <i
                                              className={cn(
                                                modifierCount === 1
                                                  ? 'fas fa-trash-alt fs-12 color-white d-flex justify-content-center align-items-center'
                                                  : 'fas fa-minus fs-12 color-white d-flex justify-content-center align-items-center'
                                              )}
                                            />
                                          </TouchableButton>
                                        )}
                                      </div>
                                      {/* 2. qty */}
                                      {showQty && (
                                        <div className="col-2 px-0 text-center fw-600 d-flex justify-content-center align-items-center fs-14 color-black">
                                          {' '}
                                          {modifierCount
                                            ? modifierCount * (data.weight || 1)
                                            : ''}
                                        </div>
                                      )}
                                      {/* 3. plus button */}
                                      <div className="col-5 px-0">
                                        {!showOnlyCount && showQty && (
                                          <TouchableButton
                                            type="button"
                                            style={{
                                              borderRadius: '0.1rem',
                                              backgroundColor:
                                                serverAppTheme?.primaryBtn,
                                            }}
                                            className={cn(
                                              "modifierBtn",
                                              'color-white border-0 w-100 justify-content-center align-items-center',
                                              `${hideBtns}`,
                                              style.modifierInc,
                                              !hideBtns && 'd-flex'
                                            )}
                                            onClick={e => {
                                              e.stopPropagation();
                                              if (disable || isLimitOver) return
                                              isKiosk ||
                                                isTableTop ||
                                                modifierGroup?.isWeight === false
                                                ? onCountModifer(
                                                  isActive,
                                                  data,
                                                  isLimitOver,
                                                  true,
                                                  item,
                                                  modifierCount,
                                                  e
                                                )
                                                : onClickAddModifer(
                                                  isActive,
                                                  data,
                                                  isLimitOver,
                                                  true,
                                                  item,
                                                  modifierCount,
                                                  e
                                                );
                                            }}
                                            aria-label="plusModQtyBtn"
                                          >
                                            <i
                                              className={cn(
                                                'fas fa-plus fs-12 d-flex justify-content-center align-items-center color-white'
                                              )}
                                              role="presentation"
                                            />
                                          </TouchableButton>
                                        )}
                                      </div>
                                    </div>
                                    {/* } */}
                                  </>
                                )}
                            </div>
                          </div>
                        )}
                    </div>
                  </>
                )}
                {!isServerApp && item?.tags?.length > 0 && (
                  <div
                    className={cn(
                      'd-flex flex-row mb-1'
                    )}
                  >
                    {item.tags.map(tag => {
                      return (
                        <small
                          key={tag.name}
                          className={cn(
                            'badge',
                            isActive ? 'color-black' : 'text-white'
                          )}
                        >
                          {tag.shortName}
                        </small>
                      );
                    })}
                  </div>
                )}
                {!isServerApp &&
                  supportsModifierDescription &&
                  item &&
                  item.description !== null && (
                    <div
                      className={cn(
                        style.lineHeight1,
                        'd-flex my-2 pb-10 fs-12',
                        isActive ? style.modDescription : '',
                        !(item.outOfStock === true || item.badge !== 0) &&
                          !(item.tags && item.tags.length > 0) &&
                          !(
                            data.price > 0 ||
                            (item.calories !== null && item.calories > 0)
                          )
                          ? 'pb-20'
                          : ''
                      )}
                    >
                      {item.description && item.description.length > 120
                        ? `${item.description.substring(0, 80)}...`
                        : item.description}
                    </div>
                  )}
              </div>
            </div>
          )}
        </>
      )}
      {isLeftSwipeWithNestedModifier && (
        <div
          style={{ zIndex: '1', bottom: '0', paddingRight: '0.18rem' }}
          className="col-12 pl-0 h-42 position-absolute d-flex justify-content-center align-items-center"
        >
          {(isActive ||
            (!isActive &&
              !isSlider &&
              !data.singleSelection &&
              !itemInfo.menuItem.outOfStock)) && (
              <div
                style={{
                  backgroundColor: serverAppTheme?.drop_left_modifier,
                  padding: '0.15rem 0',
                }}
                className="col-12 h-100 px-0 d-flex  bg-black justify-content-end align-items-center"
              >
                <div
                  className={cn('col-3 h-100 d-flex justify-content-center px-0')}
                >
                  {!isNestedModifier && !isKiosk && disableModifierMemosValue() && (
                    <TouchableDiv
                      id={data.modifierId}
                      onClick={e => {
                        e.preventDefault();
                        e.stopPropagation();
                        const temp = { ...modifierNote };
                        handleNote(
                          temp[Number(modId) + '_' + modifierGroup.id]?.note,
                          Number(modId),
                          true,
                          modifierGroup.id
                        );
                      }}
                      className={cn(
                        'col-11 px-0 d-flex align-items-center justify-content-center',
                        !isActive && style.disableActionBtn
                      )}
                      style={{
                        borderRadius: '0.1rem',
                        backgroundColor: isActive
                          ? '#9E7B00'
                          : serverAppTheme?.menu_btn_disable_text,
                      }}
                      role="presentation"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={'22'}
                        height={'22'}
                        viewBox="0 0 16 16"
                      >
                        <mask
                          maskUnits="userSpaceOnUse"
                          x="0"
                          y="0"
                          width="16"
                          height="16"
                        >
                          <rect
                            width="16"
                            height="16"
                            fill={
                              isActive
                                ? '#FFF'
                                : serverAppTheme?.menu_btn_disable_text
                            }
                          />
                        </mask>
                        <g mask="url(#mask0_819_1964)">
                          <path
                            d="M5.20589 10.7941H9.0294V9.91178H5.20589V10.7941ZM5.20589 8.44116H10.7941V7.55884H5.20589V8.44116ZM5.20589 6.08821H10.7941V5.20589H5.20589V6.08821ZM4.06336 13C3.76622 13 3.51471 12.8971 3.30882 12.6912C3.10294 12.4853 3 12.2338 3 11.9366V4.06336C3 3.76622 3.10294 3.51471 3.30882 3.30882C3.51471 3.10294 3.76622 3 4.06336 3H11.9366C12.2338 3 12.4853 3.10294 12.6912 3.30882C12.8971 3.51471 13 3.76622 13 4.06336V11.9366C13 12.2338 12.8971 12.4853 12.6912 12.6912C12.4853 12.8971 12.2338 13 11.9366 13H4.06336ZM4.06336 12.1177H11.9366C11.9819 12.1177 12.0234 12.0988 12.0611 12.0611C12.0988 12.0234 12.1177 11.9819 12.1177 11.9366V4.06336C12.1177 4.0181 12.0988 3.97662 12.0611 3.9389C12.0234 3.90119 11.9819 3.88234 11.9366 3.88234H4.06336C4.0181 3.88234 3.97662 3.90119 3.9389 3.9389C3.90119 3.97662 3.88234 4.0181 3.88234 4.06336V11.9366C3.88234 11.9819 3.90119 12.0234 3.9389 12.0611C3.97662 12.0988 4.0181 12.1177 4.06336 12.1177Z"
                            fill={isActive ? '#FFF' : '#636363'}
                          />
                        </g>
                      </svg>
                    </TouchableDiv>
                  )}
                </div>
                <div
                  className={cn('col-3 h-100 d-flex justify-content-center px-0')}
                >
                  {!isKiosk &&
                    !isTableTop &&
                    !isNestedModifier &&
                    isGlobalModFuncDisplay && (
                      <TouchableDiv
                        id={data.modifierId}
                        onClick={e => {
                          e.preventDefault();
                          e.stopPropagation();
                          if (data?.modifierId === selectedModId) {
                            setModId();
                            handleGlobalModFunction();
                          } else if (data?.modifierId) {
                            setModId(data.modifierId);
                            handleGlobalModFunction(
                              modifierGroup.id,
                              data.modifierId
                            );
                          }
                        }}
                        className={cn(
                          'col-11 px-0  fw-500 d-flex align-items-center justify-content-center',
                          isActive
                            ? data?.modifierId === selectedModId
                              ? 'bg-secondary color-white'
                              : 'color-white'
                            : style.disableActionBtn
                        )}
                        style={{
                          borderRadius: '0.1rem',
                          fontSize: 'Max(2vw, 2vh)',
                          pointerEvents: !isActive && 'none',
                          backgroundColor: isActive
                            ? data?.modifierId === selectedModId
                              ? 'bg-secondary color-white '
                              : serverAppTheme?.primaryBtn
                            : serverAppTheme?.menu_btn_disable_text,
                        }}
                        role="presentation"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="14"
                          height="14"
                          viewBox="0 0 11 11"
                          fill="none"
                        >
                          <path
                            d="M1.5 9.5C1.225 9.5 0.989583 9.40208 0.79375 9.20625C0.597917 9.01042 0.5 8.775 0.5 8.5V1.5C0.5 1.225 0.597917 0.989583 0.79375 0.79375C0.989583 0.597917 1.225 0.5 1.5 0.5H8.5C8.775 0.5 9.01042 0.597917 9.20625 0.79375C9.40208 0.989583 9.5 1.225 9.5 1.5V5.675C9.34167 5.61667 9.17917 5.57292 9.0125 5.54375C8.84583 5.51458 8.675 5.5 8.5 5.5V1.5H1.5V8.5H5.5C5.5 8.675 5.51458 8.84583 5.54375 9.0125C5.57292 9.17917 5.61667 9.34167 5.675 9.5H1.5ZM8.5 10.5L7.8 9.8L8.5875 9H6.5V8H8.5875L7.8 7.2L8.5 6.5L10.5 8.5L8.5 10.5ZM4.5 7.5H5.5V5.5H7.5V4.5H5.5V2.5H4.5V4.5H2.5V5.5H4.5V7.5Z"
                            fill="white"
                          />
                        </svg>
                      </TouchableDiv>
                    )}
                </div>
                <div
                  className={cn('col-3 h-100 d-flex justify-content-center px-0')}
                >
                  {!['kiosk'].includes(flowType()) &&
                    showEdit(data.modifierId) &&
                    showNestedIcon &&
                    isActive && (
                      <TouchableDiv
                        style={{
                          borderRadius: '0.1rem',
                          backgroundColor: serverAppTheme?.primaryBtn,
                        }}
                        className={cn(
                          'col-11 px-0 d-flex align-items-center justify-content-center '
                        )}
                        role="presentation"
                        onClick={e => {
                          e.preventDefault();
                          e.stopPropagation();
                          if (
                            !itemInfo.menuItem.outOfStock &&
                            !(item.badge === 1 || item.badge === 6) &&
                            !isSlider
                          ) {
                            if (!item.outOfStock) {
                              onClickModifer(
                                isActive,
                                data,
                                isLimitOver,
                                item,
                                'edit'
                              );
                            }
                          }
                        }}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="14"
                          height="14"
                          viewBox="0 0 12 12"
                          fill="none"
                        >
                          <path
                            d="M10.24 4.08796H4.77418C4.40598 4.08796 4.10622 4.3864 4.10622 4.75296V7.08861H1.86536V1.85708H7.12028V3.07274C7.12028 3.28507 7.29372 3.45774 7.507 3.45774C7.72028 3.45774 7.89372 3.28507 7.89372 3.07274V1.75208C7.89372 1.38552 7.59395 1.08709 7.22575 1.08709H1.75989C1.39168 1.08709 1.09192 1.38552 1.09192 1.75208V7.19361C1.09192 7.56017 1.39168 7.8586 1.75989 7.8586H6.65504L5.9334 8.57703C5.86028 8.64983 5.81997 8.74643 5.81997 8.84933C5.81997 8.95222 5.86028 9.04882 5.93317 9.12162C6.00606 9.19419 6.10333 9.23432 6.20669 9.23432C6.31004 9.23432 6.40684 9.19442 6.4802 9.12162L7.66286 7.944C7.7327 7.87447 7.78497 7.79327 7.81825 7.70203C7.867 7.63624 7.89348 7.55597 7.89348 7.4736C7.89348 7.39124 7.867 7.3112 7.81825 7.2454C7.78497 7.15394 7.7327 7.07274 7.66286 7.00344L6.47997 5.82582C6.40684 5.75302 6.30981 5.71288 6.20645 5.71288C6.10309 5.71288 6.00606 5.75302 5.9334 5.82582C5.7827 5.97585 5.7827 6.22015 5.9334 6.37018L6.65504 7.08861H4.87965V4.85796H10.1346V10.0895H4.87965V8.84933C4.87965 8.63699 4.70622 8.46433 4.49293 8.46433C4.27965 8.46433 4.10622 8.63699 4.10622 8.84933V10.1945C4.10622 10.561 4.40598 10.8595 4.77418 10.8595H10.24C10.6082 10.8595 10.908 10.561 10.908 10.1945V4.75296C10.908 4.3864 10.6082 4.08796 10.24 4.08796Z"
                            fill="#FFFFFF"
                          />
                        </svg>
                      </TouchableDiv>
                    )}
                </div>
                <div
                  className={cn('col-3 h-100 d-flex justify-content-center px-0')}
                >
                  <TouchableDiv
                    style={{
                      borderRadius: '0.1rem',
                      border: `1px solid ${serverAppTheme?.primary_text}`,
                    }}
                    className={cn(
                      'col-11 px-0 d-flex align-items-center justify-content-center'
                    )}
                    role="presentation"
                    onClick={e => {
                      e.preventDefault();
                      e.stopPropagation();
                      if (isActive || !isActive) {
                        setIsLeftSwipeWithNestedModifier(
                          !isLeftSwipeWithNestedModifier
                        );
                      }
                    }}
                  >
                    <svg
                      width="13"
                      height="12"
                      viewBox="0 0 13 12"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M5.24218 6L11.5323 1.66948e-08L13 1.4L8.20378 6L13 10.6L11.5323 12L5.24218 6Z"
                        fill={serverAppTheme?.primary_text}
                      />
                      <path
                        d="M-7.34442e-06 6L6.29012 1.66948e-08L7.75781 1.4L2.96159 6L7.75781 10.6L6.29012 12L-7.34442e-06 6Z"
                        fill={serverAppTheme?.primary_text}
                      />
                    </svg>
                  </TouchableDiv>
                </div>
              </div>
            )}
        </div>
      )}
    </TouchableDiv>
  );
};

const Modifier = props => {
  const {
    showEdit,
    modifierGroup,
    modifiersHashTable,
    onClickModifier,
    onClickAddModifier,
    onClickModifierCounter,
    onClickNegitiveModifierCounter,
    modifierData,
    nestedModifierArray,
    modifierGroupsHashTable,
    itemInfo,
    onSlideChange,
    isNestedModifier,
    updateCollapsedModifier,
    collapsedModifierArray,
    menuItemId,
    auth,
    modifierNote,
    handleNote,
    handleGlobalModFunction,
    browserOrtablet,
    setBrowserOrtablet,
    serverAppTheme,
    globalModFuncDisplayIds,
    showNestedIcon,
    setShowNestedIcon,
    modifier,
    modifierEdit,
    selectedModifiers,
    activeModGroup,
  } = props;
  const [collapse, setCollapse] = useState(() => true);
  const [disable, setDisable] = useState(() => false);
  const [max, setMax] = useState(0);
  const [count, setCount] = useState(0);
  const [selectedModArray, setSelectedModArray] = useState(() => {
    return [];
  });
  const [modCount, setModCount] = useState(true);
  const [isModCollapsed, setModCollapsed] = useState(
    getObjectValue(() => modifierGroup.displayStyle.collapsed, false)
  );
  const supportsModifierDescription = useMemo(
    () =>
      getObjectValue(
        () => auth.guestAppFeatures.supportsModifierDescription,
        false
      ),
    []
  );
  const isServerApp = flowType() === 'serverApp';
  const [selectedModId, setModId] = useState();
  const isCounter = useMemo(
    () =>
      getObjectValue(
        () =>
          isServerApp && [1].includes(props.deviceInfo.deviceGroup.startMode),
        false
      ),
    []
  );

  const isDriveThru = useMemo(
    () =>
      getObjectValue(
        () =>
          isServerApp && [3].includes(props.deviceInfo.deviceGroup.startMode),
        false
      ),
    []
  );
  const [activeGroupName, setActiveGroupName] = useState({});

  useLayoutEffect(() => {
    if (isModCollapsed) {
      setCollapse(false);
    }
  }, [isModCollapsed, menuItemId]);

  useLayoutEffect(() => {
    setMax(modifierGroup.maximum);
  }, [modifierGroup]);

  const isNestedModifierSelected = modifier => {
    const index = findIndex(
      modifierData.filter(e => e),
      path => {
        path.startsWith(
          `${getPath(
            nestedModifierArray,
            `${modifier.modifierId}-${modifierGroup.id}`
          )}`
        );
      }
    );
    return index !== -1;
  };

  const onModifierSelect = (isActive, data, item) => {
    const operator = data.weight && data.weight > 0 ? data.weight : 1;
    const countTemp = isActive ? count - operator : count + operator;
    const modMax = modifierGroup.maximum;
    let modArray = modMax === 1 ? [] : selectedModArray;
    if (!isActive) {
      const itemModIndex = modArray.indexOf(data.name || item.name);
      if (itemModIndex === -1) {
        modArray.push(data.name || item.name);
        if (!isKiosk && !isTableTop) {
          if (props.modifierData.length > 0) {
            for (const modifier of props.modifierData) {
              if (modifier?.includes('|')) {
                const [firstPart, secondPart] = modifier.split('|');
                const id = firstPart.split('-')[0];
                const nameVal = props.modifiersHashTable[id]?.name;
                if (nameVal === modArray[0]) {
                  const pushId = secondPart.split('-')[0];
                  modArray.push(props.modifiersHashTable[pushId]?.name);
                }
              }
            }
          }
        }
      }
    } else {
      const itemIndex = selectedModArray.indexOf(data.name || item.name);
      modArray = modArray
        .slice(0, itemIndex)
        .concat(modArray.slice(itemIndex + 1, modArray.length));
    }
    setSelectedModArray(modArray);
    setCount(countTemp);
    if (modCount && collapsedModifierArray.length > 0) {
      if (
        collapsedModifierArray.indexOf(modifierGroup.id) > -1 ||
        (countTemp >= modMax && modMax !== 0)
      ) {
        setCollapse(false);
      } else {
        setCollapse(true);
      }
    } else if (countTemp >= modMax && modMax !== 0) {
      setCollapse(false);
    } else {
      setCollapse(true);
    }
  };

  const handleModSelect = () => {
    let isActive = false;
    modifierGroup.modifierLinks.forEach(data => {
      if (
        modifiersHashTable[data.modifierId] &&
        modifiersHashTable[data.modifierId].modifierGroupLinks?.length > 0
      ) {
        (
          (modifiersHashTable[data.modifierId] || []).modifierGroupLinks || []
        ).forEach(modGroup => {
          (
            (modifierGroupsHashTable[modGroup.modifierGroupId] || [])
              .modifierLinks || []
          ).forEach(mod => {
            const firstPath = getPath(
              nestedModifierArray,
              `${data.modifierId}-${modifierGroup.id}`
            );
            const finalPath = firstPath.concat(
              '|',
              `${mod.modifierId}-${modGroup.modifierGroupId}`
            );
            isActive =
              modifierData.includes(`${finalPath}`) ||
              modifierData.includes(`${firstPath}`);
            if (isActive) {
              const item = modifiersHashTable[data.modifierId];
              onModifierSelect(false, data, item);
            }
          });
        });
      } else {
        isActive = modifierData.includes(
          `${getPath(
            nestedModifierArray,
            `${data.modifierId}-${modifierGroup.id}`
          )}`
        );
        const item = modifiersHashTable[data.modifierId];
        if (isActive) {
          onModifierSelect(false, data, item);
        }
      }
    });
    setModCount(false);
  };

  const checkNestedMinModSelected = () => {
    const newArray = [];
    modifierData.forEach(modifier => {
      if (
        modifier.startsWith(getPath(nestedModifierArray)) &&
        modifier.includes('|')
      ) {
        if (modifier.replace(getPath(nestedModifierArray), '')) {
          newArray.push(modifier.replace(getPath(nestedModifierArray), ''));
        }
      }
    });
    const modifierListGroupById = _.groupBy(
      newArray,
      d => d.split('-')[1].split('|')[0]
    );
    if (
      (modifierListGroupById[modifierGroup.modifierGroupId] || []).length <
      modifierGroup.minimum
    ) {
      setCollapse(true);
    } else {
      setCollapse(false);
    }
  };

  useLayoutEffect(() => {
    let countTemp = 0;
    (modifierGroup.modifierLinks || []).forEach(data => {
      const isActive = modifierData.includes(
        `${getPath(
          nestedModifierArray,
          `${data.modifierId}-${modifierGroup.id}`
        )}`
      );
      if (isActive) {
        if (data.weight && data.weight > 0) {
          countTemp +=
            data.weight *
            filter(
              modifierData,
              d =>
                d ===
                `${getPath(
                  nestedModifierArray,
                  `${data.modifierId}-${modifierGroup.id}`
                )}`
            ).length;
        } else {
          countTemp +=
            1 *
            filter(
              modifierData,
              d =>
                d ===
                `${getPath(
                  nestedModifierArray,
                  `${data.modifierId}-${modifierGroup.id}`
                )}`
            ).length;
        }
      }
    });
    let hasNestedTemp = false;
    (modifierGroup.modifierLinks || []).forEach(nMod => {
      if (
        modifiersHashTable[nMod.modifierId] &&
        modifiersHashTable[nMod.modifierId].modifierGroupLinks?.length > 0
      ) {
        hasNestedTemp = false;
      }
    });
    if (
      countTemp >= modifierGroup.maximum &&
      modifierGroup.maximum !== 0 &&
      (modifierGroup.maximum !== 1 || hasNestedTemp)
    ) {
      setDisable(true);
    }
    setCount(countTemp);
  }, [modifierData, menuItemId]);

  useLayoutEffect(() => {
    if (modifierGroup.minimum > 0) {
      if (isNestedModifier) {
        checkNestedMinModSelected();
      }
    }
    if (modifierData.length > 0 && modCount) {
      handleModSelect();
    }
  }, [modifierData, isNestedModifier, menuItemId]);

  const onClickModifierCount = (isActive, weight) => {
    const operator = weight && weight > 0 ? weight : 1;
    const countTemp = isActive ? count - operator : count + operator;
    setCount(countTemp);
    if (countTemp > max) {
      setCount(countTemp - operator);
    }
    if (countTemp === max && max !== 0 && max !== 1) {
      setDisable(true);
    } else {
      setDisable(false);
    }
  };

  useLayoutEffect(() => {
    if (!modCount && !disable) {
      setCollapse(true);
    }
  }, [disable]);

  useLayoutEffect(() => {
    const modIdArray = collapsedModifierArray || [];
    const modIndex = modIdArray.indexOf(modifierGroup.id);
    if (!collapse && !isModCollapsed) {
      setModCollapsed(false);
      if (modIndex === -1) {
        modIdArray.push(modifierGroup.id);
      }
      setActiveGroupName({});
    }
    if (!modCount && !isModCollapsed) {
      updateCollapsedModifier(modIdArray);
    }
  }, [collapse]);

  const onClickModifer = (
    isActive,
    data,
    isLimitOver,
    item,
    key,
    isGlobalModFuncDisplay,
    e
  ) => {
    if(e) e.stopPropagation();
    const modData = JSON.parse(window.sessionStorage.getItem('globalMod'));
    const check =
      modData?.modifierData?.filter(item => item.includes(data.modifierId))
        ?.length > 0;
    if (
      isLimitOver &&
      !check &&
      modifierGroup.isWeight
    ) {
      return;
    }
    if (!isKiosk && !isTableTop && modifierGroup.isWeight === true) {
      for (const element of props.modifierData) {
        const Idelement = element.split('|')[0]?.split('-')[1];
        const leftElement = element.split('|')[0]?.split('-')[0];
        if (
          modifierGroup.id === Number(Idelement) &&
          Number(leftElement) !== data.modifierId
        ) {
          if (count === modifierGroup?.maximum && !check) {
            return;
          }
        }
      }
    }
    if (
      modifiersHashTable[data.modifierId].modifierGroupLinks?.length > 0 &&
      !window.sessionStorage.getItem('nestModId')
    ) {
      window.sessionStorage.setItem('nestModId', data.modifierId);
      window.sessionStorage.setItem('modGroup', JSON.stringify(modifierGroup));
    }
    if ((!disable && !isLimitOver) || isActive) {
      setModCount(false);
      onClickModifierCount(isActive, data.weight);
      onClickModifier(
        data.modifierId,
        modifierGroup.id,
        isActive,
        key,
        isGlobalModFuncDisplay
      );
      onModifierSelect(isActive, data, item);
    }
  };

  const onClickAddModifer = (
    isActive,
    data,
    isLimitOver,
    item,
    key,
    isGlobalModFuncDisplay,
    e
  ) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    if (
      modifiersHashTable[data.modifierId].modifierGroupLinks?.length > 0 &&
      !window.sessionStorage.getItem('nestModId')
    ) {
      window.sessionStorage.setItem('nestModId', data.modifierId);
      window.sessionStorage.setItem('modGroup', JSON.stringify(modifierGroup));
    }
    if ((!disable && !isLimitOver) || isActive) {
      setModCount(false);
      onClickModifierCount(isActive, data.weight);
      onClickAddModifier(
        data.modifierId,
        modifierGroup.id,
        isActive,
        key,
        isGlobalModFuncDisplay
      );
      onModifierSelect(isActive, data, item);
    }
  };
  const onModifierCountChange = (isActive, weight, e) => {
    if (e) {
      e.preventDefault();
    }
    const operator = weight && weight > 0 ? weight : 1;
    const countTemp = isActive ? count - operator : count + operator;
    setCount(countTemp);
    if (countTemp > max) {
      setCount(countTemp - operator);
    }
    if (countTemp === max && max !== 0) {
      setDisable(true);
    } else {
      setDisable(false);
    }
  };

  const handleModArray = (data, item, modifierCount, e) => {
    if (e) e.preventDefault();
    let modArray = selectedModArray;
    if (modifierCount === 1) {
      const itemIndex = selectedModArray.indexOf(data.name || item.name);
      modArray = modArray
        .slice(0, itemIndex)
        .concat(modArray.slice(itemIndex + 1, modArray.length));
    }
    setSelectedModArray(modArray);
  };

  const handleModArrayPop = (data, item, modifierCount) => {
    let modArray = selectedModArray;
    if (modifierCount === 1) {
      const itemIndex = selectedModArray.indexOf(data.name || item.name);
      modArray = modArray
        .slice(0, itemIndex)
        .concat(modArray.slice(itemIndex + 1, modArray.length));
      modArray.splice(modArray.length - 1, 1);
    } else {
      modArray.splice(modArray.length - 1, 1);
    }
    setSelectedModArray(modArray);
  };

  const onCountNegitiveModifer = (
    isActive,
    data,
    isLimitOver,
    isInc,
    item,
    modifierCount,
    e
  ) => {
    onModifierCountChange(!isInc, data.weight, e);
    onClickNegitiveModifierCounter(data.modifierId, modifierGroup.id, isInc);
    handleModArrayPop(data, item, modifierCount);
  };

  const onCountModifer = (
    isActive,
    data,
    isLimitOver,
    isInc,
    item,
    modifierCount,
    e
  ) => {
    onModifierCountChange(!isInc, data.weight, e);
    if (isInc && !disable && !isLimitOver) {
      onClickModifierCounter(data.modifierId, modifierGroup.id, isInc, e);
    } else if (!isInc) {
      onClickModifierCounter(data.modifierId, modifierGroup.id, isInc, e);
      handleModArray(data, item, modifierCount, e);
    }
  };
  const onSlideSelect = (data, remove) => {
    onSlideChange(data, remove);
  };
  const toggleCollapse = () => {
    setCollapse(!collapse);
  };

  const isModifierRequired = modifierGroup.minimum > 0;
  let modifierGroupList = [];
  if (modifierGroup) {
    modifierGroupList = _.sortBy(
      _.chain(modifierGroup.modifierLinks)
        .groupBy('groupName')
        .map((value, key) => ({ groupName: key, items: value }))
        .value(),
      d => d.index
    );
  }
  const isGlobalModFuncDisplay =
    props?.menusList[props.menuIndex]?.globalModifierGroupIds?.length > 0;
  const [visible, setVisible] = useState(false);
  const ref = useRef(null);
  const options = {
    root: document.querySelector('#modifiersContainer'),
    rootMargin: '0px',
    threshold: [0.1, 0.9],
  };
  const handleObserver = (entries, observe) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        setVisible(true);
        observe.unobserve(entry.target);
      }
    });
  };
  useLayoutEffect(() => {
    const observer = new IntersectionObserver(handleObserver, options);
    if (ref.current) {
      observer.observe(ref.current);
    }
    return () => {
      observer.disconnect();
    };
  }, []);

  useEffect(() => {
    if (!isKiosk && activeModGroup[modifierGroup?.id]) {
      setCollapse(true);
    }
  }, [!isKiosk && activeModGroup[modifierGroup?.id]]);

  return (
    <div
      ref={ref}
      key={props.key}
      className={cn(
        'rounded pb-1 pt-2 px-2',
        isModifierRequired
          ? cn(style.modifierContainer)
          : cn(style.optionModifierContainer),
        modifierGroup.hiddenAutoAddMenuItemId !== null &&
          !modifierGroup.hiddenMenuId
          ? 'd-none'
          : '',
        modifierGroup.hiddenAutoAddModifierId !== null &&
          !modifierGroup.hiddenMenuId
          ? 'd-none'
          : '',
        props.menusList.length > 0 &&
          props.menusList[props.menuIndex].id === modifierGroup.hiddenMenuId &&
          modifierGroup.hiddenAutoAddModifierId
          ? 'd-none'
          : ''
      )}
      style={{
        backgroundColor: isModifierRequired
          ? serverAppTheme?.requiredModifierGroupBg
          : serverAppTheme?.optional_modifier_bg,
        border: isModifierRequired ? serverAppTheme?.card_border : 'none',
      }}
    >
      <TouchableDiv
        className={cn('mb-2 fs-14 fw-700 d-flex flex-column')}
        onClick={e => {
          e.preventDefault();
          e.stopPropagation();
          toggleCollapse();
        }}
        role="presentation"
        modifier-group={modifierGroup.id}
        id={modifierGroup.id}
      >
        <div
          className={cn(
            'd-flex',
            ['kiosk'].includes(flowType()) && 'fs-14',
            style.modifierNameContainer
          )}
        >
          <span className={cn('fs_14 fw-500')}>
            {modifierGroupsHashTable[modifierGroup.id]?.name || ''}
          </span>
          <div className={cn('d-flex mr-2')}>
            <div className="mr-0">
              <span
                className={cn(
                  'pt-1 pull-right fs_12 fw-100',
                  style.requiredModifierCount
                )}
              >
                {getSelections(modifierGroup)}
              </span>
            </div>
            <span className="px-1">
              {!collapse && (
                <DownArrow
                  fill={serverAppTheme?.iconcolor}
                  height={'12px'}
                  width={'8px'}
                />
              )}
              {collapse && (
                <UpArrow
                  fill={serverAppTheme?.iconcolor}
                  height={'12px'}
                  width={'8px'}
                />
              )}
            </span>
          </div>
        </div>
        {!collapse && selectedModArray && selectedModArray.length > 0 && (
          <div className="d-flex flex-column">
            {selectedModArray.map(item => {
              return (
                <span
                  key={item}
                  className={cn(
                    'fw-500',
                    isKiosk ? 'fs-20 ml-3' : 'ml-2 fs_12'
                  )}
                >
                  {item || ''}
                </span>
              );
            })}
          </div>
        )}
      </TouchableDiv>
      {isServerApp && (
        <div className="d-flex flex-row o-group-menu overflowX w-100 overflowY align-items-center pb-1">
          {modifierGroupList?.map((el, index) => {
            return el.groupName != 'null' && el.groupName !== '' ? (
              <TouchableDiv
                key={el.id}
                style={{
                  minHeight: '26px',
                  borderRadius: '8px',
                  color: props?.serverAppTheme?.primary_text,
                  border: `1px solid ${serverAppTheme?.modifiers_border}`,
                  backgroundColor: activeGroupName[el.groupName]
                    ? serverAppTheme?.selected
                    : serverAppTheme?.modSubGrpBtn,
                }}
                className={cn(
                  'flex-shrink-0 inline-flex text-nowrap px-2 mx-1 fw-400 fs_14 py-1',
                  index != 0 ? 'mx-1' : 'mr-1'
                )}
                tabIndex="0"
                role="button"
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  setActiveGroupName(prev => ({
                    [el.groupName]: !prev[el.groupName],
                  }));
                  !collapse && setCollapse(true);
                }}
                rippleEffect={true}
              >
                {el?.groupName?.length > 9
                  ? `${el?.groupName?.substring(0, 9)}...`
                  : el?.groupName}
              </TouchableDiv>
            ) : (
              <></>
            );
          })}
        </div>
      )}
      {visible &&
        modifierGroupList[0]?.items?.length > 0 &&
        modifierGroupList.map(modGroupList => (
          <>
            {modGroupList.groupName !== 'null' &&
              (activeGroupName && Object.values(activeGroupName)[0]
                ? activeGroupName[modGroupList.groupName]
                : true) && (
                <div
                  className={cn('fw-700 fs-16 py-1', collapse ? '' : 'd-none')}
                >
                  {modGroupList.groupName}
                </div>
              )}
            <div className={cn(collapse ? 'row mx-0' : 'd-none')}>
              {modGroupList.items.map((data, index) => {
                const item = modifiersHashTable[data.modifierId];
                const isActive = modifierData.includes(
                  `${getPath(
                    nestedModifierArray,
                    `${data.modifierId}-${modifierGroup.id}`
                  )}`
                );

                const remainingWeight = max - count;
                const isLimitOver = max > 1 && data?.weight > remainingWeight;

                const modifierCount = filter(
                  modifierData,
                  d =>
                    d ===
                    `${getPath(
                      nestedModifierArray,
                      `${data.modifierId}-${modifierGroup.id}`
                    )}`
                ).length;
                let hideBtns = '';
                if (modifierGroup.maximum === 1) {
                  hideBtns = 'd-none';
                }
                const getGlobalMod = data => {
                  let value = JSON.parse(
                    window.sessionStorage.getItem('globalMod')
                  );
                  return (
                    value?.modifiers?.find(val => val.modifierId === data)
                      ?.modifiers?.length > 0
                  );
                };
                const showOnlyCount =
                  (disable ||
                    (max !== 0 &&
                      max !== 1 &&
                      max < count + (data.weight || 1))) &&
                  modifierCount === 1;                  

                const isSlider =
                  getObjectValue(
                    () =>
                      modifierGroupsHashTable[
                        modifiersHashTable[data.modifierId]
                          .modifierGroupLinks[0].modifierGroupId
                      ].displayStyle.slider,
                    false
                  ) === true;
                return (
                  (activeGroupName && Object.values(activeGroupName)[0]
                    ? activeGroupName[data.groupName]
                    : true) && (
                    <RenderMods
                      {...props}
                      data={data}
                      modifierGroup={modifierGroup}
                      modId={data?.modifierId}
                      itemInfo={itemInfo}
                      item={item}
                      isSlider={isSlider}
                      showEdit={showEdit}
                      onClickModifer={onClickModifer}
                      onClickAddModifer={onClickAddModifer}
                      onCountNegitiveModifer={onCountNegitiveModifer}
                      isActive={isActive}
                      isLimitOver={isLimitOver}
                      isGlobalModFuncDisplay={isGlobalModFuncDisplay}
                      modifiersHashTable={modifiersHashTable}
                      disable={disable}
                      isServerApp={isServerApp}
                      supportsModifierDescription={supportsModifierDescription}
                      isNestedModifier={isNestedModifier}
                      modifierNote={modifierNote}
                      handleNote={handleNote}
                      showOnlyCount={showOnlyCount}
                      hideBtns={hideBtns}
                      onCountModifer={onCountModifer}
                      modifierCount={modifierCount}
                      handleGlobalModFunction={handleGlobalModFunction}
                      auth={auth}
                      isNestedModifierSelected={isNestedModifierSelected}
                      onSlideSelect={onSlideSelect}
                      modifierGroupsHashTable={modifierGroupsHashTable}
                      getGlobalMod={getGlobalMod}
                      selectedModId={selectedModId}
                      setModId={setModId}
                      browserOrtablet={browserOrtablet}
                      setBrowserOrtablet={setBrowserOrtablet}
                      isCounter={isCounter}
                      isModifierRequired={isModifierRequired}
                      serverAppTheme={serverAppTheme}
                      index={index}
                      globalModFuncDisplayIds={globalModFuncDisplayIds}
                      showNestedIcon={showNestedIcon}
                      setShowNestedIcon={setShowNestedIcon}
                      modifier={modifier}
                      modifierEdit={modifierEdit}
                      selectedModifiers={selectedModifiers}
                      isDriveThru={isDriveThru}
                      maxValue={max}
                      itemWeight={data?.weight || 1}
                      itemCount={count}
                    />
                  )
                );
              })}
            </div>
          </>
        ))}
    </div>
  );
};
export default Modifier;
